// Copyright (c) Docugami, Inc. All rights reserved.

import { IDocumentCommand } from "components/file_management/DocumentCommand";
import { getFileUxName, isDirectory } from 'components/file_management/file_helpers';
import { useDgDownloader } from 'hooks/downloader';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'store';

export function useDownloadFilesCommand(items: string[], onComplete?: (error?: any) => void): IDocumentCommand {
    const [isActive, setIsActive] = useState(false);
    const orgId = useSelector((state: AppState) => state.organizations.currentOrganization?.id);
    const dgDownloader = useDgDownloader(orgId);

    function getSelectedItemPaths(): string[] {
        return Array.from(new Set(items));
    }

    function onClick() {
        setIsActive(true);

        if (items.length === 1 && !isDirectory(items[0])) {
            const filepath = items[0];
            dgDownloader.downloadFile(filepath, getFileUxName(filepath, false));
        }
        else {
            const paths = getSelectedItemPaths();
            dgDownloader.downloadFiles(paths);
        }
    }

    useEffect(() => {
        if (!isActive) {
            return;
        }

        if (dgDownloader.canDownloadFiles()) {
            setIsActive(false);
            onComplete?.();
        }

    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dgDownloader]);

    return {
        id: "DownloadFilesCommand",
        isActive: isActive,
        label: dgDownloader.canDownloadFiles() ? "Download" : "Downloading...",
        isEnabled: items.length > 0,
        visual: null,
        execute: onClick
    }
}
